import { put } from 'redux-saga/effects';

import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { ContentActionsService } from '../../commonInfra/contentActions/ContentActions';
import { EditSimulationReduxAction } from '../actions/EditSimulationReduxAction';

export function* handleEditSimulation(action: EditSimulationReduxAction) {
  try {
    ContentActionsService.editSimulation(action.simulation.luid);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
